import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  ms: {
    "取消": 'Batal',
    "确定": 'Sahkan',
    "发送": 'Hantar',
    "系统通知": 'Pemberitahuan Sistem',
    "关闭": 'Tutup',
    "图片": 'Imej',
    "文件": 'Fail',
    "表情": 'Emotikon',
    "视频": 'Video',
    "录制": 'Merekam',
    "拍照": 'Memotret',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
